module.exports = __webpack_public_path__ + "static/img/csn.3054c4de.png";